import StaticMap from './map-builder';

interface MapZsgOptions {
  width: number;
  height: number;
  scale: number;
  zoom: number;
  lat: number;
  lng: number;
}

const getMapZsg = function getMapZsg(options: MapZsgOptions) {
  const staticMap = new StaticMap();

  staticMap
    .size(options.width, options.height)
    .scale(options.scale)
    .zoom(options.zoom)
    .markers(options.lat, options.lng)
    .style({
      feature: 'poi',
      element: 'labels',
      visibility: 'off',
    });

  return staticMap;
};

export { getMapZsg };
